import React, { FC } from 'react';
import classnames from 'classnames';
import { wantToOpenInNewTab } from '../../../utils/linkUtils';
import styles from './chart_legend_item.module.scss';

type Props = {
  handleClick?: (openInNewTab: boolean) => void;
  clickable: boolean;
  color: string;
  label: JSX.Element;
  hasBorder: boolean;
};

export const ChartLegendItem: FC<Props> = ({
  handleClick = () => {},
  label,
  clickable,
  color,
  hasBorder,
}) => {
  return (
    <li
      onClick={event =>
        clickable && handleClick && handleClick(wantToOpenInNewTab(event))
      }
      className={classnames(styles.item, { [styles.pointer]: clickable })}
    >
      <span className={styles.color} style={{ backgroundColor: color }} />
      <span className={classnames(styles.text, { [styles.border]: hasBorder })}>
        {label}
      </span>
    </li>
  );
};
